import React from "react";
import moment from "moment";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import PaginationFooter from "components/util/helpers/PaginationFooter";

const HistoryView = ({
  chats = [],
  isLoading = false,
  pageNum = 1,
  totalPages = 0,
  currentChatId,
  processName,
  resumingChatId,
  setPageNum = () => { },
  onClickChat = () => { },
  onClickResumeChat = () => { },
  onClose = () => { },
}) => (
  <div className="chat-history-panel animate__animated animate__fadeIn animate__faster">

    {/* Header */}
    <div className="chat-history-panel-header d-flex align-items-center">
      <i className="fas fa-clock-rotate-left mr-2" />
      <span className="text-truncate">
        {l("Conversaciones anteriores%CH032")}
        {processName && <span className="chat-history-panel-process ml-2">{processName}</span>}
      </span>
      <button
        type="button"
        className="chat-history-panel-close ml-auto"
        title={l("Cerrar%GA089")}
        onClick={onClose}>
        <i className="fas fa-times" />
      </button>
    </div>

    {/* List */}
    <div className="chat-history-panel-body">

      {isLoading && <Loading />}

      {!isLoading && chats.length == 0 &&
        <div className="chat-history-panel-empty text-center">
          <i className="fas fa-comments fa-2x mb-3" />
          <div>{l("Aún no hay conversaciones anteriores%CH033")}</div>
        </div>}

      {!isLoading && chats.map(chat =>
        <HistoryChatItem
          key={`history-chat-${chat.id}`}
          chat={chat}
          isCurrent={chat.id == currentChatId}
          isResuming={chat.id == resumingChatId}
          onClickChat={onClickChat}
          onClickResumeChat={onClickResumeChat}
        />)}

    </div>

    {totalPages > 1 &&
      <div className="chat-history-panel-footer">
        {/* The panel is as narrow as the chat, so it fits five pages plus both arrows */}
        <PaginationFooter
          pageNum={pageNum}
          totalPages={totalPages}
          maxVisiblePages={5}
          onClickPage={setPageNum}
        />
      </div>}

  </div>
);

// A conversation left mid-process is offered as "resume" instead of "open": clicking it
// puts the run back where it stopped, which is the only way an interrupted process — or
// a form nobody answered in time — becomes answerable again.
const HistoryChatItem = ({
  chat,
  isCurrent,
  isResuming,
  onClickChat,
  onClickResumeChat,
}) => (
  <div
    className={"chat-history-panel-item" + (isCurrent ? " current" : "")}
    onClick={() => onClickChat(chat.id)}>

    <div className="d-flex align-items-center">

      <div className="flex-fill overflow-hidden">
        <div className="chat-history-panel-item-title text-truncate">
          {chat.title || l("Sin título%CH034")}
        </div>
        <div className="chat-history-panel-item-date">
          {moment(chat.updatedAt).format("DD MMM · HH:mm")}
        </div>
      </div>

      {chat.resumableExecution &&
        <button
          type="button"
          className="chat-history-panel-item-btn"
          onClick={(event) => {
            event.stopPropagation();
            onClickResumeChat(chat.id);
          }}>
          {isResuming && <i className="fas fa-spinner fa-pulse mr-2" />}
          {!isResuming && <i className="fas fa-play mr-2" />}
          {l("Reanudar%VC010")}
        </button>}

    </div>

    {chat.resumableExecution?.status == "ABORTED" &&
      <div className="chat-history-panel-item-tag">{l("Proceso interrumpido%CH035")}</div>}

    {chat.resumableExecution?.status == "AWAITING" &&
      <div className="chat-history-panel-item-tag">{l("En espera de tu respuesta%CH036")}</div>}

  </div>
);

export default HistoryView;
